"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styles = require("../../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

const getWidth = {
  small: "275",
  medium: "464",
  large: "550"
};

const StyledDiv = _styledComponents2.default.div.withConfig({
  displayName: "InputForSearch__StyledDiv",
  componentId: "sc-19ihxxw-0"
})(["", " display:flex;align-items:center;height:40px;width:", "px;border:1px solid ", ";border-radius:6px;padding-left:", "px;box-sizing:border-box;&:focus-within{border-color:", ";color:", ";outline:none;}& input{border:none;padding-left:", "px;&:focus{outline:none;box-shadow:none;}&::-webkit-input-placeholder{color:", ";}&::-moz-placeholder{color:", ";}&:-ms-input-placeholder{color:", ";}&:-moz-placeholder{color:", ";}}"], _styles.defaultBody, props => getWidth[props.size], _styles.colors.border, (0, _styles.calcPadding)(4), _styles.colors.accentFocusInput, _styles.colors.black, (0, _styles.calcPadding)(3), _styles.colors.greyInput, _styles.colors.greyInput, _styles.colors.greyInput, _styles.colors.greyInput);

class InputForSearch extends _react.Component {
  render() {
    const _props = this.props,
          { size, placeholder } = _props,
          props = _objectWithoutProperties(_props, ["size", "placeholder"]);

    return _react2.default.createElement(
      StyledDiv,
      _extends({ size: size }, props),
      _react2.default.createElement(
        "svg",
        {
          width: "16px",
          height: "16px",
          viewBox: "0 0 16 16",
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          xlink: "http://www.w3.org/1999/xlink"
        },
        _react2.default.createElement(
          "desc",
          null,
          "Created with Sketch."
        ),
        _react2.default.createElement(
          "g",
          {
            id: "Symbols",
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            fillOpacity: "0.25"
          },
          _react2.default.createElement(
            "g",
            {
              id: "Input-/-Large-Search",
              transform: "translate(-16.000000, -12.000000)",
              fill: "#15191E",
              fillRule: "nonzero"
            },
            _react2.default.createElement("path", {
              d: "M16,18.6292689 C16,22.2788032 18.9866211,25.2654244 22.6361555,25.2654244 C24.0391203,25.2654244 25.3391169,24.8158022 26.4107421,24.069742 L29.9986283,27.6506049 C30.4550981,28.1139419 31.2011779,28.1139419 31.6576477,27.6506049 C32.1141174,27.1941351 32.1141174,26.4549225 31.6576477,25.9984332 L28.0689811,22.410547 C28.8226694,21.3322303 29.2646635,20.0327994 29.2646635,18.6291323 C29.2646635,14.9795979 26.2780424,12 22.6355312,12 C18.9858408,12.0001366 16,14.9791492 16,18.6292689 Z M26.922071,18.629464 C26.922071,21.0140397 25.0138641,22.9222076 22.6361555,22.9222076 C20.2515798,22.9222076 18.3434119,21.0140007 18.3434119,18.629464 C18.3434119,16.2448882 20.2516188,14.3367204 22.6361555,14.3367204 C25.0139032,14.3367204 26.922071,16.2449272 26.922071,18.629464 Z",
              id: "Shape"
            })
          )
        )
      ),
      _react2.default.createElement("input", _extends({ placeholder: placeholder }, props))
    );
  }
}

InputForSearch.defaultProps = {
  size: "small",
  placeholder: "Search for ..."
};

InputForSearch.propTypes = {
  className: _propTypes2.default.string,
  placeholder: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(["small", "medium", "large"])
};

exports.default = InputForSearch;